import { RootState } from '../../store';

export const getPositionSelector = (state: RootState) => state?.positionReducer?.position;
